export default "__VITE_ASSET__nt4_X$lo__"